import { render, staticRenderFns } from "./QueryRiskAccumulation.vue?vue&type=template&id=0cd4efa7&"
import script from "./QueryRiskAccumulation.vue?vue&type=script&lang=js&"
export * from "./QueryRiskAccumulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports